export default "__VITE_ASSET__CTeVI6AH__"